/* days string will be passed in as a csv.  So a list of numbers seperated by a comma all inside a string */
export function extractDaysOfWeek(days: string): number[] {
  if (!days || days.trim() === '') return [];
  if (days === '*') return [...Array(7).keys()];
  return days.split(',').map((day) => parseInt(day, 10));
}
